import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faSearch } from '@fortawesome/free-solid-svg-icons';
import useAsync from '../hooks/useAsync';
import AdminServices from '../services/AdminServices';
import Permissions from './UserPermission';
import Modal from 'react-modal';
import DeleteButton from './Button/DeleteButton';
import { Link } from 'react-router-dom';
import UpdateAdmin from './Update Model/UpdateAdmin';
import Pagetitle from './PageTitle';

Modal.setAppElement('#root');

function AdminUser() {
  const { data, error, isLoading, run } = useAsync(AdminServices.getAllAdmin);
  const [admins, setAdmins] = useState([]);
  const [filteredAdmins, setFilteredAdmins] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [roleFilter, setRoleFilter] = useState('');
  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (data && data.status) {
      setAdmins(data.data);
      setFilteredAdmins(data.data);
    }
  }, [data]);

  // Filter logic
  useEffect(() => {
    const filtered = admins.filter((admin) => {
      const matchesSearch =
        admin.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        admin.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
        admin.mobileNo.toLowerCase().includes(searchQuery.toLowerCase());

      const matchesRole = roleFilter ? admin.role === roleFilter : true;

      return matchesSearch && matchesRole;
    });
    setFilteredAdmins(filtered);
  }, [searchQuery, roleFilter, admins]);

  const handleViewDetails = (admin) => {
    setSelectedUser(admin);
    setIsModalOpen(true);
  };
  const handleEditDetails = (admin) => {
    setSelectedEdit(admin);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const handleDelete = (admin) => {
    setSelectedEdit(admin);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    
    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return 'Invalid Date';
    }
  
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
  
    return `${day}/${month}/${year}`;
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  // if (error) {
  //   return <div>Error loading data: {error.message}</div>;
  // }

  return (
    <div className="right_col" role="main">
      <Pagetitle></Pagetitle>
      <div className="container-box px-0 user-manager" style={{ overflowX: "auto", whiteSpace: "nowrap", marginBottom: "20px" }}>
        <div className="container-box-top-header px-4">
        <div className="container-box-top-header-left-2">
            <input
              type="search"
              name="search"
              placeholder="Search Name, Email, or Mobile No."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button className="search-btn">
              <FontAwesomeIcon icon={faSearch} />
            </button>
          </div>

          <div className="sub-title-box-right d-flex">
            <div>
              <select
                className="dropdown"
                value={roleFilter}
                onChange={(e) => setRoleFilter(e.target.value)}
              >
                <option value="">Select Role</option>
                <option value="Admin">Admin</option>
                <option value="Investor">Investor</option>
                <option value="User">User</option>
                <option value="Helper">Helper</option>
              </select>
            
            </div>
            <Link className="Add-new-btn site-btn-green ms-3" to="/add-admin-user">
              <img src="img/add-plus.svg" alt="" />
              <span className="ms-2">Add New</span>
            </Link>
          </div>
        </div>
        <div className="container-box-inner">
          {filteredAdmins.length > 0 ? (
            <table id="example" className="table table-striped" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Role</th>
                  <th>Name</th>
                  <th>Email Address</th>
                  <th>Mobile No.</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredAdmins.map((admin, index) => (
                  <tr key={admin?._id}>
                    <td>{index + 1}</td>
                    <td><button class="statusBtnActive" style={{
                      backgroundColor:
                        admin.role === "Admin"
                          ? "#551756"
                          : admin.role === "Investor"
                            ? "#FF7373"
                            : admin.role === "User"
                              ? "#3572EF"
                              : admin.role === "Helper"
                                ? "#007320" 
                                : "transparent", 
                      color: "#fff",
                    }}>{admin?.role}</button></td>
                    <td>{admin?.name}</td>
                    <td>{admin?.email}</td>
                    <td>{admin?.mobileNo}</td>
                    <td>{formatDate(admin?.createdAt)}</td>
                    <td >
                    <td>{admin?.status}</td>
                    </td>
                    <td>
                      <div className="action_toggle_outer">
                        <button className="action_toggle" onClick={() => toggleActionMenu(index)}>
                          <i className="fa fa-ellipsis-v" />
                        </button>
                        {activeIndex === index && (
                          <div className="action_toggle_content product-edit show d-block">
                            <ul className="list-unstyled">
                              <li>
                                <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                  <i className="fa fa-close" />
                                </button>
                              </li>
                              <li>
                                <button className="edit" style={{backgroundColor : "#F98F42"}} onClick={() => handleEditDetails(admin)}>Edit</button>
                              </li>
                              <li>
                                <button className="reject" onClick={() => handleDelete(admin)}>Delete</button>
                              </li>
                              <li>
                              <button className="reject" style={{ backgroundColor: '#263238' }} onClick={() => handleViewDetails(admin)}>Permission</button>
                            </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className='text-center'>No admins found.</div>
          )}
        </div>
        <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Admin Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <Permissions admin={selectedUser} closeModal={closeModal} />
      </Modal>
        <Modal
          isOpen={isEditModalOpen}
          onRequestClose={closeEditModal}
          contentLabel="User Details"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <UpdateAdmin admin={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
        </Modal>
        <Modal
          isOpen={isDeleteModalOpen}
          onRequestClose={closeDeleteModal}
          contentLabel="Delete Confirmation"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <DeleteButton data={selectedEdit} page="Admin" closeModal={closeDeleteModal} onSuccess={run} />
        </Modal>
      </div>
    </div>
  );
}

export default AdminUser;
